<template>
</template>

<script>
import Vue from 'vue';

export default {
    data: function () {
        return {
            page: 1,
            totalPages: 100,
            error: false,
            reviews: [],
            showWidgets: [],
        }
    },
    props: [
        'queryUrl',
    ],
    mounted() {
        this.queryApi();
    },
    methods: {

        /**
         * Query the internal API to trigger a free lookup on MotorCheck
         *
         * @return  {void}
         */
        queryApi() {
            axios
                .post(this.queryUrl, {page: this.page})
                .then(response => {
                    this.error = false;

                    this.reviews = this.reviews.concat(response.data.data);
                    this.totalPages = response.data.meta.pagination.total_pages;
                })
                .catch(error => {
                    this.error = true;
                })
        },

        showShareWidgets(index) {
            if (this.showWidgets[index] == false || this.showWidgets[index] == null) {
                this.$set(this.showWidgets, index, true);
            } else if (this.showWidgets[index] == true) {
                this.$set(this.showWidgets, index, false);
            }
        },

        loadNextPage() {
            this.page = this.page + 1;

            Vue.nextTick().then(function () {
                this.queryApi();
            }.bind(this));
        },
    },
}
</script>
